import { get, post } from "./config/request"

export default {
    /* 通用 */
    common: {
        /* 首页 */
        index() {
            return get(`/index`)
        },
        /* 最新动态 */
        trend() {
            return get('/trends')
        },
        /* 首页 */
        special() {
            return get(`/index/special`)
        },

        //配置
        config() {
            // return Promise.resolve({"code":400,"msg":"站点尚未开通","data":[]})
            return get(`/config`)
        },

        //幻灯
        slider() {
            return get(`/slider`)
        },

        //菜单
        menu(params) {
            return get(`/columns`, params)
        },

        //友情链接
        friendlink() {
            return get(`/friendlinks`)
        },

        /* 获取面包屑 */
        breadcrumb(params) {
            return get('/breadcrumb', params)
        }

    },

    /* 栏目 */
    column: {
        // 栏目信息
        info(params) {
            return get('/columns/column', params)
        }
    },

    /* 内容 */
    content: {
        // 列表
        list(params) {
            return get('/contents', params)
        },

        // 详细
        detail(params) {
            return get('/contents/'+params.id, params)
        },
    },

    /* 专题 */
    special: {
        // 专题列表
        list(params) {
            return get('/special', params)
        },

        // 专题内容列表
        content_list(params) {
            return get('/special/'+params.id, params)
        }
    },

    /* 留言 */
    message: {
        // 留言列表
        list(params) {
            return get('/message', params)
        },

        // 提交留言
        reply(params) {
            return post('/message', params)
        },

        // 验证码
        captcha() {
            return get('/message/captcha')
        }
    },

    /* 搜索 */
    search: {
        search(params) {
            return get('/search', params)
        },
    },

    /* 广告 */
    ad: {
        index(position) {
            return get('/ad', position)
        }
    },


    /* 菜单 */
    /*menu: {
        index() {
            return post('/index')
        }
    }*/
    //...
}

/* 获取后台配置信息 */
/*export function index_data(params) {
    return request.get('/index_data', params)
}*/

/* 获取后台配置信息 */
/*
export function config(params) {
    return request.get('/config', params)
}

/!* 获取站点Logo *!/
export function logo(params) {
    return request.get('/logo', params)
}

/!* 搜索 *!/
export function search(params) {
    return request.get('/search', params)
}

/!* 获取图片新闻列表 *!/
export function imageNews(params) {
    return request.get('/image_news', params)
}

/!* 获取幻灯 *!/
export function sliders(params) {
    return request.get('/sliders', params)
}
/!* 获取菜单 *!/
export function menus(params) {
    return request.get('/menus', params)
}

/!* 获取指定分类下的内容 *!/
export function getArticleListByMenuType(data) {
    return request.get('/article', data)
}

/!* 获取指定分类下的内容 *!/
export function getAticleDetail(data) {
    return request.get('/article'+data.page+data.id)
}
/!* 获取通知内容 *!/
export function getNoticeDetail(data) {
    return request.get('/notice/'+data.id)
}

/!* 获取通知内容 *!/
export function ad(params) {
    return request.post('/ad/', params)
}
/!*帐号注册*!/
export function register(data){
    return request.post('/auth/register',data)
}
/!*测试获取信息*!/
export function getPlotList(params){
    return request.get('/plots',params)
}
*/

/*数据列表*/
